import React, { useState, useEffect } from "react";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = window.sessionStorage.getItem("jwtToken");

const CATEGORIES = [
  "Daily Bytes",
  "Market Nuggets",
  "Market Events",
  "Strategies",
  "Support Center",
  "Uncategorized",
];

const AddOrEditNewsletterForm = ({
  initialData = null,
  onSuccess = () => {},
  onError = () => {},
  onClose = () => {},
}) => {
  const [formData, setFormData] = useState({
    id: "",
    text: "",
    description: "",
    htmlPage: null,
    backgroundImage: null,
    blogImages: [],
    category: "",
  });

  const [isEdit, setIsEdit] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (initialData) {
      setFormData({
        id: initialData.id || "",
        text: initialData.text || "",
        description: initialData.description || "",
        htmlPage: null,
        backgroundImage: null,
        blogImages: [],
        category: initialData.categories || "",
      });
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }
  }, [initialData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;

    if (name === "blogImages") {
      setFormData((prev) => ({
        ...prev,
        blogImages: [...prev.blogImages, ...files],
      }));
    } else {
      setFormData({ ...formData, [name]: files[0] });
    }
  };

  const handleRemoveImage = (index) => {
    setFormData((prev) => ({
      ...prev,
      blogImages: prev.blogImages.filter((_, i) => i !== index),
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("text", formData.text);
    data.append("description", formData.description);
    if (formData.htmlPage) data.append("htmlPage", formData.htmlPage);
    if (formData.backgroundImage)
      data.append("backgroundImage", formData.backgroundImage);
    if (isEdit) data.append("id", formData.id);
    if (formData.category) data.append("category", formData.category);

    formData.blogImages.forEach((file) => {
      data.append("blogImage", file);
    });

    try {
      const response = await fetch(
        `${BASE_URL}/newsletter/${isEdit ? "edit" : "upload"}`,
        {
          method: "POST",
          body: data,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.ok) {
        setMessage(
          isEdit ? "Blog updated successfully!" : "Blog added successfully!",
        );
        onSuccess(isEdit);
        onClose();
      } else {
        const errorText = await response.text();
        console.error("Upload failed:", errorText);
        setMessage("Failed to save blog.");
        onError();
      }
    } catch (error) {
      console.error("Error uploading:", error);
      setMessage("Error occurred while saving.");
      onError();
    }
  };

  return (
    <form onSubmit={handleFormSubmit}>
      <div className="mb-3">
        <label className="form-label fw-bold">Text</label>
        <textarea
          name="text"
          value={formData.text}
          onChange={handleInputChange}
          className="form-control"
          required
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">Description</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleInputChange}
          className="form-control"
          required
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">Category</label>
        <select
          name="category"
          value={formData.category}
          onChange={handleInputChange}
          className="form-control"
          required
        >
          <option value="">Select a category</option>
          {CATEGORIES.map((category) => (
            <option key={category} value={category}>
              {category}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">HTML Page</label>
        <input
          type="file"
          name="htmlPage"
          className="form-control"
          onChange={handleFileChange}
          accept=".html"
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">Background Image</label>
        <input
          type="file"
          name="backgroundImage"
          className="form-control"
          onChange={handleFileChange}
          accept="image/*"
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">Blog Images</label>
        <input
          type="file"
          name="blogImages"
          className="form-control"
          multiple
          key={formData.blogImages.length}
          onChange={handleFileChange}
          accept="image/*"
        />
      </div>

      {formData.blogImages.length > 0 && (
        <div className="mb-3">
          <p>Selected Images:</p>
          <ul>
            {formData.blogImages.map((file, index) => (
              <li key={index}>
                {file.name}
                <button
                  type="button"
                  onClick={() => handleRemoveImage(index)}
                  className="ms-2 btn-close"
                ></button>
              </li>
            ))}
          </ul>
        </div>
      )}

      {message && <p className="text-danger">{message}</p>}

      <button type="submit" className="btn btn-primary">
        {isEdit ? "Update Blog" : "submit"}
      </button>
    </form>
  );
};

export default AddOrEditNewsletterForm;
